import { Component, OnInit } from '@angular/core';
import { MatListItem, MatNavList } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';

import { loadTodosFromPage } from '../../../store/todo/todo.actions';
import { Todo } from '../../../models/todo';
import { selectTodos } from '../../../store/todo/todo.selector';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-todo-list',
  imports: [MatNavList, MatListItem, AsyncPipe, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './todo-list.component.html',
  styleUrl: './todo-list.component.scss'
})
export class TodoListComponent implements OnInit {
  todos$: Observable<Todo[]>;


  constructor(
    private store: Store,
  ) {
    this.todos$ = this.store.select(selectTodos);
  }

  ngOnInit(): void {
    this.store.dispatch(loadTodosFromPage());
  }
}
